import { ThemeLightDarkIcon } from './ThemeLightDarkIcon';

/**
 * author: Austin Andrews
 * id AE66BEF4-7040-4A15-8BF3-639B116853CC
 * name theme-light-dark
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/theme-light-dark.svg
 * tags
 * - Weather 
 */
export const SunMoonStarsIcon = ThemeLightDarkIcon;
export default SunMoonStarsIcon